var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"annex-preview",attrs:{"id":"container"}},[(_vm.showPdf)?_c('iframe',{attrs:{"id":"previewPdf","src":'/pdf/web/viewer.html?file=' + _vm.fileUrl,"height":"760","width":"100%"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }